import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'walletShort',
    pure: false
})
export class WalletShortPipe implements PipeTransform {


    transform(value: string, args: any[]): string {
        return value.substr(0, 5) +
            '...' +
            value.substr(value.length - 4, value.length);
    }

}